import './Player.css';

function Player({ login, position, image }) {
  return (
    <a href={"https://profile.intra.42.fr/users/" + login} className="Player"
	  style={{
		transform: `translateX(${position}vw)`,
	  }}
	>
      {image && <img src={image} alt={login} />}
      <h1>{login}</h1>
    </a>
  );
}

export default Player;
